import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import { SupportLink } from '../../common/SupportLink';
import { Link } from '@reach/router';
import Button from '@mui/material/Button';

export const PolicyStreamInvalidInsuranceTypePage = () => {
  return (
    <InvalidInsuranceContainer>
      <Typography
        variant='h1'
        sx={{
          mb: 2,
        }}
      >
        Access Restricted
      </Typography>
      <StyledTypography>
        It looks like your organization doesn’t currently have access to our
        PolicyStream Life Insurance product. If you’re interested in learning
        more or gaining access, feel free to reach out to us at{' '}
        <SupportLink subject={`Signing up for PolicyStream`} />; we'd be happy
        to help.
      </StyledTypography>

      <StyledTypography>
        If you are looking for our Commercial or Personal Insurance product,
        please <Link to='/insurtech/quote'>click here to go there.</Link>
      </StyledTypography>
      <Button component={Link} to='/'>
        Home
      </Button>
    </InvalidInsuranceContainer>
  );
};

const StyledTypography = styled(Typography)(() => {
  return { maxWidth: '560px' };
});
const InvalidInsuranceContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    gap: theme.spacing(2),
  };
});
